import "./vendor";
import "./app/app-barrel";
import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AdaptClientConfiguration } from "@common/configuration/adapt-client-configuration";
import { ServiceUri } from "@common/configuration/service-uri";
import { Logger } from "@common/lib/logger/logger";
import { ErrorHandlingUtilities } from "@common/lib/utilities/error-handling-utilities";
import { AppModule } from "app/app.module";
import { environment } from "./environments/environment";

if (environment.production) {
    enableProdMode();
}

const logger = Logger.getLogger("main");

AdaptClientConfiguration.initialiseConfiguration(environment.clientConfiguration);
ServiceUri.updateFromConfiguration(AdaptClientConfiguration);

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(ErrorHandlingUtilities.handleInitialisationError)
    .catch((err) => logger.error("Encountered an error while bootstrapping", err));
